
import { AsistenteEnLineaComponent } from './asistente-en-linea.component';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';


import { LocalStorageService, LOCAL_SERVICE_STORAGE } from './services/local-storage.service';
import { LOCAL_STORAGE } from 'ngx-webstorage-service';
import { AsistenciaMenuModule } from './components/asistencia-menu/asistencia-menu.module';
import { AsistenteVentanaModule } from './components/asistente-ventana/asistente-ventana.module';
import { BasecomponentsModule } from './basecomponents/basecomponents.module';
import { ErrorTrackingService } from './services/error-tracking.service';
import { CommonModule } from '@angular/common';
import { AsistenciaTramiteComponent } from './components/asistencia-tramite/asistencia-tramite.component';

@NgModule({
   declarations: [
      AsistenteEnLineaComponent,

   ],
   imports: [
      CommonModule,
      FormsModule,
      HttpClientModule,
      AsistenteVentanaModule,
      AsistenciaMenuModule,
      BasecomponentsModule
   ],
   exports: [
      AsistenteEnLineaComponent,
      BasecomponentsModule
   ],
   providers: [
      LocalStorageService,

      { provide: LOCAL_SERVICE_STORAGE, useExisting: LOCAL_STORAGE }

   ],
   bootstrap: [
      AsistenteEnLineaComponent
   ]
})
export class AsistenteEnLineaModule { }
